import { Fragment } from 'react';
import styled from 'styled-components';
import UserLink from 'src/modules/shared/links/userLink';
import Roles from 'src/components/roles';
import i18n from 'src/utils/translate';
import { userHasRole } from 'src/utils/context';
import { textSmall, textLinkPrimarySmall } from 'styles-js/mixins/typography';
import { useSelector } from 'src/store/store';
import { Role, EditAuthor } from 'src/constants/types';

type Props = {
  editAuthor: EditAuthor;
  marginBottom?: string;
}
export default function LastEditedBy({ editAuthor, marginBottom = '30px' }: Props): JSX.Element {
  const { currentUser, currentCommunity } = useSelector(({ context })=> context);

  const isEditAuthorPAM = userHasRole(editAuthor, [Role.Partner, Role.Administrator, Role.Moderator]);
  const isEditAuthorHU = userHasRole(editAuthor, [Role.HealthUnlocked]);

  const isUserPAM = userHasRole(currentUser, [Role.Partner, Role.Administrator, Role.Moderator]);
  const isUserHU = userHasRole(currentUser, [Role.HealthUnlocked]);

  const editedBy = () => {
    switch (true) {
      case (isEditAuthorHU && !isUserHU):
        return i18n.t('HealthUnlocked staff');
      case (isEditAuthorPAM && !isUserHU && !isUserPAM):
        return <a href={`/${currentCommunity.slug}/about#whoweare`}>{i18n.t('moderation team')}</a>;
      default:
        return (
          <Fragment>
            <UserLink user={editAuthor} />
            {' '}{editAuthor?.roles?.length > 0 && <Roles roles={editAuthor.roles} />}
          </Fragment>
        );
    }
  };

  if (!currentUser) return null;

  return (
    <LastEdited $marginBottom={marginBottom}>
      <span className="icon-pencil">
        {i18n.t('Last edited by')}{' '}
        {editedBy()}
      </span>
    </LastEdited>
  );
}

const LastEdited = styled.div<{ $marginBottom: string }>`
  ${textSmall};
  color: ${props => props.theme.colorTextLight};
  margin-bottom: ${({ $marginBottom }) => $marginBottom};

  @media (${({ theme }) => theme.underScreenSmall}) {
    margin-bottom: 20px;
  }
  a {
    ${textLinkPrimarySmall};
  }
`;
